import { OrdersService, AdminOrderResponse, UserOrderResponse, } from "@/api";

export const OrderAdminService = {

    async list(): Promise<UserOrderResponse[]> {
        const orders =
            await OrdersService.listOrdersOrdersAdminOrdersGet();
        return orders
    },

    async get(orderId: number,): Promise<AdminOrderResponse> {
        const order =
            await OrdersService.adminGetOrderByIdOrdersAdminIdGet(orderId);
        return order
    },

    async delete(
        orderId: number
    ): Promise<void> {

        await OrdersService
            .deleteOrderOrdersIdDelete(
                orderId
            );
    },

};